import React from 'react';
import InputMask from 'react-input-mask';

const PhoneInput = (props) => {
    // Component-only props — must NOT be spread onto the underlying <input>
    // (react-input-mask forwards unknown props straight to the native DOM
    // node, unlike the plain input.js variant which already excludes these).
    const {
        idValue,
        isInvalid,
        isDisabled,
        inputClassName,
        className,
        iconLeft,
        iconRight,
        errorMsg,
        label,
        showLabel,
        showOptionalLabel,
        required,
        ...rest
    } = props;

    const inputClasses = `peer order-2 block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 invalid:ring-red disabled:ring-gray-200 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed ${isInvalid ? 'ring-red-500' : ''}`;
    const combinedInputClasses = inputClassName ? `${inputClasses} ${inputClassName}` : inputClasses;

    return (
        <div className='relative flex flex-col'>
            <InputMask
                {...rest}
                className={combinedInputClasses}
                type='text'
                id={idValue}
                disabled={isDisabled}
                aria-invalid={isInvalid}
                required={required}
                mask="(999) 999-9999"
            />
            {iconLeft ? (
                <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                    {iconLeft}
                </div>
            ) : null}
            {iconRight ? (
                <div className='absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none'>
                    {iconRight}
                </div>
            ) : null}
            {errorMsg ? (
                <p className='mt-2 order-3 invisible peer-placeholder-shown:!invisible peer-placeholder-shown:!h-px peer-invalid:visible peer-invalid:h-4 h-px text-red text-sm transition-all'>
                    {errorMsg}
                </p>
            ) : null}

            {label ? (
                <label
                    htmlFor={idValue}
                    className={
                        showLabel
                            ? 'p order-1 block mb-2 text-sm font-medium leading-6 text-gray-900 peer-invalid:text-red'
                            : 'sr-only'
                    }
                >
                    {label} {required ? <span className="text-red-500">*</span> : showOptionalLabel && <span className="text-gray-500 text-xs ml-3"> (Optional)</span>}
                </label>
            ) : null}
        </div>
    );
};

export default PhoneInput;
